import React, {Component} from "react"
import {Button} from "elemental"
import shop from "shop/shop"
import swal from "sweetalert"

export default class ResetPasswordButton extends Component {

  request = () => {
    const { email } = this.props
    console.log( `request PW RESET`, email, shop )
    if ( !email ) {
      swal( "Fehler", translate( "Keine gültige E-Mail hinterlegt" ), "error" )
      return
    }
    shop.requestPassword( email )
      .then( res => {
        swal( translate( "reset.success" ),
          translate( "reset.success_explained_long" ),
          "success" )
      } )
      .catch( err => {
        swal( translate( "reset.mail_not_found" ), translate( "reset.mail_not_found_explained" ) + err, "error" )
      } )
  }

  render() {
    return <Button onClick={this.request} color="red">{translate( "reset.reset" )}</Button>
  }
}



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordButton.js